import { AppRoutes } from '@constants/app-routes'
import TopHexagon from '@public/images/animated-icons/half-top-hexagon.svg'
import LargeTriangle from '@public/images/animated-icons/large-triangle.svg'
import TriangleSmall from '@public/images/animated-icons/triangle-small.svg'
import Triangle from '@public/images/animated-icons/triangle.svg'
import { Link } from '@ui/links/Link'

import {
  BottomCatchTriangle,
  BottomCatchTriangleOrange,
  LeftSideTriangle,
  LeftSideTriangleOrange,
  TopTriangle,
  TriangleSmallOrange,
  TopHexagonOrange,
  LargeTriangleOrange,
  TopHexagonDark,
} from './styles'

const imageSize = {
  imageWidth: 60,
  imageHeight: 60,
}
export const config = {
  title: 'Build your software with Modsen',
  subtitle: (
    <>
      We have established an impeccable cooperation process that allows us to
      uncover the endless opportunities of custom software development to
      broaden your business horizons. Tap into the pool of benefits{' '}
      <Link href={AppRoutes.aboutUs}>Modsen team</Link> has to offer.
    </>
  ),

  items: [
    {
      id: 1,
      title: 'Strong in-house processes',
      text: `Our team has built a solid and agile internal processes architecture that allows us to operate swiftly and precisely on each project that comes to our hands. Properly structured in-house processes lay the foundation of the future software product and ensure its seamless error-free implementation.`,
      imagePath: '/images/animated-icons/arrow-icon.svg',
      imagePathHover: '/images/animated-icons/arrow-icon.svg', // костыль
      alt: 'Strong in-house processes',
      imageTitle: 'Strong in-house processes',
      className: 'rotate',
      ...imageSize,
      additionalImages: [
        {
          id: 'Triangle',
          imageComponent: <Triangle />,
          imageComponentHover: <TopTriangle />,
          options: {
            top: 0,
            right: 0,
          },
        },
      ],
    },
    {
      id: 2,
      title: 'High-end industry experts',
      text: `From the outset, our software development company has been focusing on gathering top-notch professionals under our roof. Today 250+ Modsen specialists work together to bring value to our partners and create exceptional software solutions.`,
      imagePath: '/images/animated-icons/owner-icon.svg',
      imagePathHover: '/images/animated-icons/owner-icon-hover.svg',
      alt: 'High-end industry experts',
      imageTitle: 'High-end industry experts',
      additionalImages: [
        {
          id: 'Triangle',
          imageComponent: <BottomCatchTriangle />,
          imageComponentHover: <BottomCatchTriangleOrange />,
          options: {
            bottom: -8,
            right: 2,
          },
        },
      ],
      ...imageSize,
    },
    {
      id: 3,
      title: 'Transparent cooperation',
      text: `Our team has worked out a clear cooperation strategy that enables our partners to monitor the process in real time and make adjustments to the product at any stage. Track the progress of your custom software development outsourcing project team and have an impeccable application built to the deadline.`,
      imagePath: '/images/animated-icons/computer.svg',
      imagePathHover: '/images/animated-icons/computer-hover.svg',
      alt: 'Transparent cooperation',
      imageTitle: 'Transparent cooperation',
      additionalImages: [
        {
          id: 'Triangle',
          imageComponent: <TriangleSmall />,
          imageComponentHover: <TriangleSmallOrange />,
          options: {
            top: 0,
            right: 0,
          },
        },
      ],
      ...imageSize,
    },
    {
      id: 4,
      title: 'Cost-optimization',
      text: `We’re looking out for our partners’ interests and that’s why always search for ways of cutting redundant expenses and incorporating cost-effective solutions during the software development process.`,
      imagePath: '/images/animated-icons/money.svg',
      imagePathHover: '/images/animated-icons/money-hover.svg',
      alt: 'Cost-optimization',
      imageTitle: 'Cost-optimization',
      additionalImages: [
        {
          id: 'Hexagon',
          imageComponent: <TopHexagonDark />,
          imageComponentHover: <TopHexagonDark />,
          options: {
            top: 11,
            right: -11,
          },
        },
        {
          id: 'Triangle',
          imageComponent: <LargeTriangle />,
          imageComponentHover: <LargeTriangleOrange />,
          options: {
            bottom: -6,
            left: 0,
          },
        },
      ],
      ...imageSize,
    },
    {
      id: 5,
      title: 'Quality code',
      text: `Code clarity and simplicity are indispensable for convenient support, servicing, and further scaling of the software. Modsen engineers ensure that your product will be easily maintained by any other specialists.`,
      imagePath: '/images/animated-icons/wheel.svg',
      imagePathHover: '/images/animated-icons/wheel.svg',
      alt: 'Quality code',
      imageTitle: 'Quality code',
      className: 'wheel-rotate',
      additionalImages: [
        {
          id: 'Triangle',
          imageComponent: <LeftSideTriangle />,
          imageComponentHover: <LeftSideTriangleOrange />,
          options: {
            bottom: 0,
            left: -73,
          },
        },
        {
          id: 'Hexagon',
          imageComponent: <TopHexagon />,
          imageComponentHover: <TopHexagonOrange />,
          options: {
            top: 0,
            right: 0,
          },
        },
      ],
      ...imageSize,
    },
    {
      id: 6,
      title: 'Guaranteed trial period',
      text: `We understand that before entrusting your project to an outsourcing software development company, you have to be sure of the quality of its processes. To eliminate any doubts and concerns, we offer a 15-day trial period for you to see Modsen from the inside and make sure of our competence.`,
      imagePath: '/images/animated-icons/touch.svg',
      imagePathHover: '/images/animated-icons/touch-hover.svg',
      alt: 'Guaranteed trial period',
      imageTitle: 'Guaranteed trial period',
      additionalImages: [
        {
          id: 'Triangle',
          imageComponent: <BottomCatchTriangle />,
          imageComponentHover: <BottomCatchTriangleOrange />,
          options: {
            bottom: -8,
            right: 2,
          },
        },
      ],
      ...imageSize,
    },
  ],
}
